var _style, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoPo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "200px",
    height: "200px",
    viewBox: "0 0 200 200",
    style: {
      enableBackground: "new 0 0 200 200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n\t.st1{fill:url(#SVGID_00000054264565685621279210000002173334718817140671_);}\r\n\t.st2{fill:url(#SVGID_00000113327415832442881720000004353014928623577236_);}\r\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 158.1,
    y1: 197.2825,
    x2: 158.1,
    y2: 16.5751
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2F6386"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4187B6"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M116.2,162.8l15.5,12.3c0,0,4-3.2,5.4-4.3s62.9-50.4,62.9-50.4h-30L116.2,162.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000036967164121555673940000007889757149761624234_",
    gradientUnits: "userSpaceOnUse",
    x1: 99.95,
    y1: 197.2825,
    x2: 99.95,
    y2: 16.5751
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2F6386"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4187B6"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000036967164121555673940000007889757149761624234_)"
    },
    d: "M149.9,30.4c-0.3,0-0.7,0-1,0 c-9.3-18.2-28.1-30-49-29.9C79,0.5,60.2,12.3,51,30.6c-0.3,0-0.7,0-1,0c-27.7,0-50,22.5-50,50c0,5.5,4.5,10,10,10s10-4.5,10-10 c0-16.5,13.4-30,29.9-30c1.8,0,3.7,0.2,5.5,0.5l8.5,1.6l2.8-8.2c4.8-14.3,18.1-23.9,33.1-23.9c15.1,0,28.4,9.5,33.2,23.8l2.8,8.2 l8.5-1.6c1.8-0.3,3.7-0.5,5.5-0.5c13.9,0,25.6,9.4,29,22.3l-178.9,48l68.4,54.6L83.8,163l-41.7-33L200,85.3v-5 C199.9,52.8,177.4,30.4,149.9,30.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000174587314472890555360000003564150558371541429_",
    gradientUnits: "userSpaceOnUse",
    x1: 99,
    y1: 197.2825,
    x2: 99,
    y2: 16.5751
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2F6386"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4187B6"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000174587314472890555360000003564150558371541429_)"
    },
    d: "M83.4,186.8l15.5,12.6l15.7-12.4 l-15.5-12.6c0,0-11,8.8-10,7.9S83.4,186.8,83.4,186.8z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoPo);
export default __webpack_public_path__ + "static/media/logo_po.9565e0b9b3d203921c7b053a1aace08c.svg";
export { ForwardRef as ReactComponent };